import { Action, Reducer } from 'redux';
import {
  QueryParamsState,
  QueryParamsTypes,
  QueryParamsActionTypes
} from './queryParamsTypes';

export const INITIAL_STATE: QueryParamsState = {
  queryParams: {
    data: null
  }
};

const queryParamsReducer: Reducer<QueryParamsState> = (
  state: QueryParamsState = INITIAL_STATE,
  action: Action
) => {
  const actionTypes = action as QueryParamsActionTypes;
  switch (actionTypes.type) {
    case QueryParamsTypes.GET_QUERY_PARAMS:
      return {
        ...state,
        queryParams: { ...state.queryParams }
      };
    case QueryParamsTypes.SAVE_QUERY_PARAMS:
      const updatedData = {
        ...state.queryParams.data,
        [actionTypes.payload.route]: actionTypes.payload.data
      };

      return {
        ...state,
        queryParams: {
          ...state.queryParams,
          data: updatedData
        }
      };
    case QueryParamsTypes.RESET_REDUCER_QUERY_PARAMS:
      return {
        ...state,
        queryParams: INITIAL_STATE.queryParams
      };
    default:
      return state;
  }
};

export default queryParamsReducer;

